import { injectReducer } from '../../store/reducers'
import {addPatientConstructor} from './modules/addpatient'

export default (store) => ({
  path : 'addpatient',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const AddPatient = require('./containers/AddPatientContainer').default
      const reducer = require('./modules/addpatient').default
      injectReducer(store, { key: 'addPatient', reducer });
      store.dispatch(addPatientConstructor());
      cb(null, AddPatient)
    }, 'addPatient')
  }
})



// WEBPACK FOOTER //
// ./src/routes/AddPatient/index.js